export function objectPath() {
    return "<ObjectPath Id=\"$$ID$$\" ObjectPathId=\"$$PATH_ID$$\" />";
}
export function identityQuery() {
    return "<ObjectIdentityQuery Id=\"$$ID$$\" ObjectPathId=\"$$PATH_ID$$\" />";
}
export function opQuery(selectProperties, childSelectProperties) {
    // this is fairly opaque behavior, but is the simplest way to convey the required information.
    // if selectProperties.length === 0 or null then select all
    // else select indicated properties
    if (selectProperties === void 0) { selectProperties = null; }
    if (childSelectProperties === void 0) { childSelectProperties = null; }
    // if childSelectProperties === null do not include that block
    // if childSelectProperties.length === 0 then select all
    // else select indicated properties
    var builder = [];
    builder.push("<Query Id=\"$$ID$$\" ObjectPathId=\"$$PATH_ID$$\">");
    if (selectProperties === null || selectProperties.length < 1) {
        builder.push("<Query SelectAllProperties=\"true\" >");
        builder.push("<Properties />");
        builder.push("</Query >");
    }
    else {
        builder.push("<Query SelectAllProperties=\"false\" >");
        builder.push("<Properties>");
        [].push.apply(builder, selectProperties.map(function (p) { return "<Property Name=\"" + p + "\" SelectAll=\"true\" />"; }));
        builder.push("</Properties>");
        builder.push("</Query >");
    }
    if (childSelectProperties !== null) {
        if (childSelectProperties.length < 1) {
            builder.push("<ChildItemQuery SelectAllProperties=\"true\" >");
            builder.push("<Properties />");
            builder.push("</ChildItemQuery >");
        }
        else {
            builder.push("<ChildItemQuery SelectAllProperties=\"false\" >");
            builder.push("<Properties>");
            [].push.apply(builder, childSelectProperties.map(function (p) { return "<Property Name=\"" + p + "\" SelectAll=\"true\" />"; }));
            builder.push("</Properties>");
            builder.push("</ChildItemQuery >");
        }
    }
    builder.push("</Query >");
    return builder.join("");
}
export function setProperty(name, type, value) {
    var builder = [];
    builder.push("<SetProperty Id=\"$$ID$$\" ObjectPathId=\"$$PATH_ID$$\" Name=\"" + name + "\">");
    builder.push("<Parameter Type=\"" + type + "\">" + value + "</Parameter>");
    builder.push("</SetProperty>");
    return builder.join("");
}
export function methodAction(name, params) {
    var builder = [];
    builder.push("<Method Id=\"$$ID$$\" ObjectPathId=\"$$PATH_ID$$\" Name=\"" + name + "\">");
    if (params !== null) {
        var arrParams = params.toArray();
        if (arrParams.length < 1) {
            builder.push("<Parameters />");
        }
        else {
            builder.push("<Parameters>");
            [].push.apply(builder, arrParams.map(function (p) { return "<Parameter Type=\"" + p.type + "\">" + p.value + "</Parameter>"; }));
            builder.push("</Parameters>");
        }
    }
    builder.push("</Method>");
    return builder.join("");
}
export function objectProperties(o) {
    return Object.getOwnPropertyNames(o).map(function (name) {
        var value = o[name];
        if (typeof value === "boolean") {
            return setProperty(name, "Boolean", "" + value);
        }
        else if (typeof value === "number") {
            return setProperty(name, "Number", "" + value);
        }
        else if (typeof value === "string") {
            return setProperty(name, "String", "" + value);
        }
        return "";
    }, []);
}
//# sourceMappingURL=opactionbuilders.js.map